import { ANONYMOUS_UI_USAGE_EVENTS_PATH, RecordUiUsageEventsResponseSchema, } from '@packages/types';
import { api, apiBeacon } from '../client.js';
/**
 * Send one batch of UI usage events. `skipAuthErrorHandling` keeps a 401 from signing the user
 * out (telemetry never ends a session), and `keepalive` lets a flush on `pagehide` outlive the
 * page.
 */
export function recordUiUsageEvents(accountId, events) {
    return api(`/accounts/${accountId}/ui-usage-events`, RecordUiUsageEventsResponseSchema, {
        method: 'POST',
        body: { events },
        skipAuthErrorHandling: true,
        keepalive: true,
    });
}
/**
 * Send one anonymous UI usage event through `apiBeacon`: no token, no cookies, one event per
 * request. Resolves when the platform accepted it and rejects with an `ApiError` otherwise;
 * the caller drops failures.
 */
export function recordAnonymousUiUsageEvent(event) {
    return apiBeacon(ANONYMOUS_UI_USAGE_EVENTS_PATH, { event });
}
